export const USER_INITIAL_STATE: UserState = {
  userId: null,
  username: null,
  email: null,
  name: null,
  firstName: null,
  lastName: null,
  location: null,
  roles: [],
  permissions: []
};

export class UserState {
  userId: number;
  username: string;
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  location: string;
  roles: string[];
  permissions: string[];
}
